// The vendored load-image.all.min.js is a UMD bundle whose internal require()
// calls esbuild cannot resolve. blueimp-load-image (same library, bundler
// friendly, pinned to the vendored 5.16.0) is used instead. jquery.fileupload-image
// expects the global window.loadImage.
import loadImage from "blueimp-load-image"

window.loadImage = loadImage

export default loadImage
